// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**** CSS For /users/messages ****/

/* message item header */
#userMessages .messageItemHeader {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

#userMessages .MessageDate {
  font-size: 18px;
  font-family: sans-serif;
  color: darkgray;
}

#userMessages h3 {
  font-size: 18px;
  font-family: sans-serif;
  color: black;
  font-weight: bold;
}

/* message item styling */
#userMessages .messageItem:first-child {
  margin-top: 4rem;
}
#userMessages .messageItem {
  border-top: 1px solid #e5e5e5;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  padding-left: 2rem;
  padding-right: 0;
}
#userMessages .messageItem:last-child {
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 3rem;
}

#userMessages .messageItem .description {
  width: 90%;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/users/messages.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB","sourcesContent":["/**** CSS For /users/messages ****/\n\n/* message item header */\n#userMessages .messageItemHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n}\n\n#userMessages .MessageDate {\n  font-size: 18px;\n  font-family: sans-serif;\n  color: darkgray;\n}\n\n#userMessages h3 {\n  font-size: 18px;\n  font-family: sans-serif;\n  color: black;\n  font-weight: bold;\n}\n\n/* message item styling */\n#userMessages .messageItem:first-child {\n  margin-top: 4rem;\n}\n#userMessages .messageItem {\n  border-top: 1px solid #e5e5e5;\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n  padding-left: 2rem;\n  padding-right: 0;\n}\n#userMessages .messageItem:last-child {\n  border-bottom: 1px solid #e5e5e5;\n  margin-bottom: 3rem;\n}\n\n#userMessages .messageItem .description {\n  width: 90%;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
